













import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class SecondaryButton extends Vue {
  @Prop({ type: String, default: '' }) readonly dataAction?: string
  @Prop({ type: String, default: '' }) readonly dataFnAction?: string
  @Prop({ type: Boolean, default: false }) readonly disableSpacing?: boolean
  @Prop({ type: Boolean, default: false }) readonly disable?: boolean
  @Prop({ type: String, default: '' }) readonly customStyle?: string
}
